<template>
	<div class="category-detail">
		<Breadcrumb :crumb="crumb"></Breadcrumb>
		<div class="detail-box flex" v-if="category">
			<div class="left">
				<div class="top-content flex">
					<div class="img-box">
						<div class="main-img">
							<img :src="category.main_image" />
						</div>
						<div class="image-list" v-if="category.image_list && category.image_list.length > 0">
							<img v-for="(img,index) in category.image_list" :key="index" class="thumbnail"
								:src="img.url" @click="changeMainImg(img.url)" />
						</div>
					</div>
					<div class="margin-left-20">
						<div class="name">{{ category.category_name_cn }}</div>
						<!-- <div class="margin-top-10">100%羊毛</div> -->
						<div class="price-box margin-top-10">
							<span>售价：￥</span>
							<span class="price">{{ category.price }}</span>
							<span class="vip-price" v-if="category.vip_price">会员价￥ {{ category.vip_price }}</span>
						</div>
						<div class="margin-top-10">款号：{{ category.style_no }}</div>
						<div class="margin-top-10">上架时间：{{ category.update_time }}</div>
						<div class="margin-top-10">累计销量：{{ category.sales}}笔</div>
						<div class="margin-top-10">发货时间：预计15天内发货</div>
						<div class="margin-top-10">销售地区：全国地区</div>
						<div class="buy-box flex">
							<div class="btn btn4" @click="go2diy(1)" v-if="calculate_mtm_type.includes(1)">DIY定制</div>
							<div class="btn btn4" @click="go2size(4)" v-if="calculate_mtm_type.includes(4)">标码定制</div>
							<div class="btn btn5" @click="go2ai(5)" v-if="calculate_mtm_type.includes(5)">商务定制</div>
							<div class="btn btn2" @click="go2customize(2)" v-if="calculate_mtm_type.includes(2)">高级定制</div>
							<div class="btn btn3" @click="go2group(3)" v-if="calculate_mtm_type.includes(3)">团体定制</div>
							<!-- <div class="buy-cart">加入购物车</div> -->
						</div>
					</div>
				</div>
				<div class="content-box">
					<div class="tabs">
						<div class="tab" v-for="(item,index) in tabs" :key="index"
							:class="tabIndex == index ? 'active': ''">{{ item.text }}</div>
					</div>

					<div class="content-json" v-for="(content,index) in category.content_json" :key="index"
						v-html="content.data.html"></div>
				</div>
			</div>
			<div class="right margin-left-20">
				<div class="hot-title">商城热卖</div>
				<div class="hot-box">
					<div class="item" v-for="(item,index) in hotList" :key="`t-${index}`"  @click="toDetail(item)">
						<img class="hot-img" :src="item.main_image" />
						<div class="item-content">
							<div class="price">￥{{ item.price }}</div>
							<div class="name">{{ item. category_name_shop || item. category_name_cn}}</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import Breadcrumb from "@/components/Breadcrumb.vue";
	import {
		getFigureList,
		MTemplateDetail,
		MTemplate,
		MCategoryAvailableMtmType
	} from "@/api"
	import util from '@/utils/util'

	export default {
		name: 'Detail',
		components: {
			Breadcrumb
		},
		data() {
			return {
				crumb: [{
					title: "商品详情",
					path: "CategoryDetail",
				}, ],
				tabIndex: 0,
				tabs: [{
					text: '商品详情'
				}],
				hasFigure: false,
				hotList:[],
				category:null,
				limit_mtm_type: "",
				available_mtm_type: "",
				choose_mtm_type: 0,
			};
		},
		computed: {
			...mapState({

			}),
			calculate_mtm_type() {
				if(!!!this.limit_mtm_type) {
					return []
				}
				if (this.category.mtm_type_string.length == 0) {
					return []
				}
				// 路径mtm_type指定类型
				let merge_mtm_type1 = !!!this.limit_mtm_type ? [] : this.limit_mtm_type.split(',')
				// 选中分类可用类型
				let merge_mtm_type2 = !!!this.available_mtm_type ? [] : this.available_mtm_type.split(',')
				let merge_mtm_type = []
				if(merge_mtm_type1.length>0 && merge_mtm_type2.length>0) {
					merge_mtm_type = util.array_intersect(merge_mtm_type1, merge_mtm_type2)
				} else if(merge_mtm_type1.length===0 && merge_mtm_type2.length>0) {
					merge_mtm_type = merge_mtm_type2
				} else if(merge_mtm_type2.length===0 && merge_mtm_type1.length>0) {
					merge_mtm_type = merge_mtm_type1
				}
				// 无类型限制则使用款可用类型
				if (merge_mtm_type.length == 0) {
					return this.category.mtm_type_string
				}

				return util.array_intersect(this.category.mtm_type_string, merge_mtm_type)
			}
		},
		watch: {
			$route(to) {
				this.id = to.query.id
				this.getDetail()
			},
		},
		mounted() {
			if(this.$route.query.mtm_type) {
				this.limit_mtm_type = this.$route.query.mtm_type
			}
			if(this.$route.query.category_id) {
				MCategoryAvailableMtmType({
					category_id: this.$route.query.category_id
				}).then(response => {
					this.available_mtm_type = response.data.mtm_type_string
				})
			}
			this.$emit('showLogin', true)
			this.$emit('showBack', false)
			this.$emit('showNav', true)
			this.$emit('showFooter', true)
		},
		created() {
			this.loadData()
			this.getDetail()
			this.getTemplateList(0)
		},
		methods: {
			go2diy(type) {
				this.choose_mtm_type = type
				this.$store.commit('mtm/update_mtm_type', type)
				this.buyNow()
			},
			go2size(type) {
				this.choose_mtm_type = type
				this.$store.commit('mtm/update_mtm_type', type)
				this.buyNow()
			},
			go2ai(type) {
				this.choose_mtm_type = type
				this.$store.commit('mtm/update_mtm_type', type)
				this.buyNow()
			},
			go2group(type) {
				this.choose_mtm_type = type
				this.$store.commit('mtm/update_mtm_type', type)
				this.$store.commit('mtm/pick', {category:this.category, mtm_type: this.choose_mtm_type})
				this.$router.push({ name: 'Design', query: {id : this.category.id}, params: {is_group: 1}})
			},
			go2customize(type) {
				this.choose_mtm_type = type
				this.$store.commit('mtm/update_mtm_type', type)
				this.buyNow()
			},
			async getTemplateList(category_id) {
				return await MTemplate({category_id,mtm_type:2}).then((response) => {
					this.hotList = response.data
				})
			},
			async getDetail() {
				const {
					data
				} = await MTemplateDetail({id: this.$route.query.id})
				this.category = data
			},
			async loadData() {
				const {
					data
				} = await getFigureList()
				this.hasFigure = data.list.length > 0 ? true : false
			},
			changeMainImg(url) {
				this.category.main_image = url
			},
			buyNow() {
				// if (!this.hasFigure) {
				// 	this.$Notice.warning({
				// 		title: '请先添加量体信息'
				// 	});
				// 	setTimeout(() => {
				// 		this.$router.push({
				// 			path: '/figure_body_form',
				// 		})
				// 	}, 500)
				// 	return
				// }
				this.$store.commit('mtm/pick', {category:this.category, mtm_type: this.choose_mtm_type})
				this.$router.push({
					name: 'Design',
					query: {id : this.$route.query.id}
				})

			},
			toDetail(item) {
				this.$router.push({
					path: '/category_detail',
					query:{
						id:item.id
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.category-detail {
		width: 1170px;
		margin: 20px auto;

		.detail-box {
			width: 980px;
			margin-top: 20px;
		}

		.top-content {
			height: 467px;
			padding: 20px;
			border: 1px solid #DDDDDD;
			color: #333333;

			.main-img {
				width: 350px;
				height: 350px;
			}

			.image-list {
				margin-top: 10px;
				.thumbnail {
					width: 52px;
					height: 52px;
					margin-right: 10px;
				}
			}

			.name {
				font-size: 16px;
				font-family: PingFang SC;
				font-weight: bold;
				color: #333333;
			}

			.price-box {
				width: 570px;
				height: 82px;

				background: #F8F8F8;
				padding: 0 10px;
				color: #0F114A;
				font-size: 18px;
				display: flex;
				align-items: center;
				.price {
					font-size: 30px;
					font-weight: bold;
					margin-right: 10px;
				}

			}

			.buy-box {
				margin-top: 50px;
				.btn {
					width: 160px;
					height: 45px;
					line-height: 45px;
					text-align: center;
					margin-right: 30px;
					cursor: pointer;
					font-size: 18px;
					font-weight: 600;
				}
				.btn4 {
					background: #0F114A;
					color: #FFF;
					border: 1px solid #DDD;
				}
				.btn5 {
					background: #E6E6EC;
					color: #0F114A;
					border: 1px solid #0F114A;
				}
				.btn2 {
					background: #FFF;
					color: #0F114A;
					border: 1px solid #0F114A;
				}
				.btn3 {
					background: #FFF;
					color: #666;
					border: 1px solid #DDD;
				}
				.buy-cart {
					width: 160px;
					height: 45px;
					line-height: 45px;
					background: #EDD4AC;
					font-size: 18px;
					color: #0F114A;
					text-align: center;
					cursor: pointer;
				}
			}
		}

		.content-box {
			margin-top: 20px;
			padding: 0 20px;
			border: 1px solid #DDDDDD;

			.tabs {
				height: 50px;
				line-height: 50px;

				.tab {
					width: 72px;
					text-align: center;
					font-size: 18px;
					font-family: PingFang SC;
					font-weight: bold;

					&.active {
						color: #0F114A;
						border-bottom: 3px solid #0F114A;
					}
				}
			}

			.content-json {
				margin-top: 10px;

			}

		}

		.right {
			width: 170px;
			.hot-title {
				width: 170px;
				height: 34px;
				line-height: 34px;
				background: #0f114a;
				text-align: center;
				color: #ffffff;
				font-size: 11px;
			}
			.hot-box{
				border: 1px solid #DDDDDD;
				padding: 10px;
				.item{
					padding-bottom: 10px;
					margin-bottom: 10px;
					border-bottom: 1px dashed #DDDDDD;
					cursor: pointer;
					.hot-img{
						width: 150px;
						height: 150px;
					}
					.item-content{
						.price{
							font-size: 13px;
							font-weight: bold;
							color: #0F114A;
						}
						.name{
							font-size: 10px;
							color: #333333;
							overflow: hidden;
							text-overflow:ellipsis;
							white-space: nowrap;
						}
					}
				}
			}

		}
	}

	.margin-top-10 {
		margin-top: 10px;
	}

	.margin-left-20 {
		margin-left: 20px;
	}
</style>
